export default __webpack_public_path__ + "static/media/MANA.5b365467.png";